// extracted by mini-css-extract-plugin
export default {"ratings":"Ratings_ratings__fNK0u","ratingsFlex":"Ratings_ratingsFlex__ZpUD5","flexColumn":"Ratings_flexColumn__7asdw"};